import React from "react";
import ReactTable from "react-table";
import find from "lodash/find";
import moment from "moment";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../common/Pagination/Pagination";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function ESPFollowUpsGrid(props)
{
    const columns = [
		{
			id: "service_id",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
			Header: "Service ID",
			accessor: "nResourceInstanceId",
			width:118,
		},
		{
			id: "service_name",
			Header: "Service Name",
			headerStyle:{'borderBottom':'solid 1px #ccc'},
			accessor: "nResourceInstanceId",
            style: { 'whiteSpace': 'unset' },
			width:220,
			Cell: ({ original }) => (
					<>
					<div className="conv-mb30">
							<span style={{wordBreak:"break-all",width:"210px"}}>{original.service_details.sServiceName}</span>
						</div>
					</>
				),
		},
		{
			id: "sFirstName"+"service_id",
			Header: "Customer Details",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
			accessor: "nResourceInstanceId",
            style: { 'whiteSpace': 'unset' },
			width:330,
			Cell: ({ original }) => (
				<>
                   <div className="conv-mb30">
                        <span className="inline-label feedback-customer-label">Name</span>
                        <span style={{wordBreak:"break-all",float:"right",width:"210px"}}>{original.service_details.sFirstName+" "+original.service_details.sLastName}</span>
                    </div>
                    <div style={{clear:"both"}}></div>
                    <div className="conv-mb30">
                        <span className="inline-label feedback-customer-label">E-mail ID</span>
                        <span style={{wordBreak:"break-all",float:"right",width:"210px"}}>{original.service_details.sEmailAddress}</span>
                    </div>
                    <div style={{clear:"both"}}></div>
                    <div>
                        <span className="inline-label feedback-customer-label">Phone No.</span>
                        <span style={{wordBreak:"break-all",float:"right",width:"210px"}}>{original.service_details.sContactNumber}</span>
                    </div>
				</>
			),
		},
		{
			id: "facilitator_name",
			Header: "Facilitator Name",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
			accessor: "nResourceInstanceId",
            style: { 'whiteSpace': 'unset' },
			width:210,
			Cell: ({ original }) => (
				<>
					{
						<span style={{wordBreak:"break-all",width:"210px"}}>{original.service_details.existing_service_facilitator?original.service_details.existing_service_facilitator.email:""}</span>
						
					}
				</>
			),
		},
        {
			id: "bHandled",
			Header: "Completed",
			accessor: "bHandled",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','wordBreak':'break-all'},
			width:80,
			Cell: ({ original }) => {
				return original["bHandled"] ? (
					<span>Yes</span>
				) : (
					<span>No</span>
				);
			},
		},
		{
			id: "dtFollowupOn",
			Header: "Follow Up On",
			accessor: "dtFollowupOn",
			width:170,
			Cell: ({ original }) => {
				return original["dtFollowupOn"] ? (
					<span style={{whiteSpace:"break-spaces",width:"150px"}}>
						{moment(
							moment.utc(original["dtFollowupOn"]).toDate()
						).format("MMMM Do YYYY")}
					</span>
				) : (
					<span>-</span>
				);
			},
		},
		{
			id: "MarkCompleted",
			Header: "Action",
			width:180,
			accessor: "nResourceInstanceId",
			Cell: ({ original }) =>
				(
					<>	
						<button className="btn r-button primary"
							onClick={(e) =>props.handleSaveFollowUp(e,original)}>
							Mark Completed
						</button>
					</>	
				),
		},
    ];

    return (
            <ReactTableFixedColumns
                minRows={0}
                data={props.data || []}
                columns={columns}
                //manual
                //defaultPage={props.page}
                //pages={props.pages}
                //page={props.page}
                pageSize={props.data.length}
                sortable={false}
                //defaultPageSize={10}
                showPagination={false}
                //pageSizeOptions={[10,20,30]}
                //onFetchData={(state, instance) => {
                    //props.fetchESPCustomerFeedbackData(instance, false);
                //}}
                //onPageSizeChange={props.onPageSizeOptionChange}
                PaginationComponent={Pagination}
                style={{overflowY: "initial",height: "550px"}}			
                /*NextComponent={(instance) => (
                    <Button className="mt3" {...instance}>
                        Next
                    </Button>
                )}*/
                /*PreviousComponent={(instance) => (
                    <Button className="mt3" {...instance}>
                        Previous
                    </Button>
                )}*/
                className="-striped hide-scrollbar"
            />
    )
}